import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { App } from './app/app';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';

// Configure PDF.js worker
import * as pdfjsLib from 'pdfjs-dist';
// Set the worker source to use the bundled worker from assets
pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/pdf.worker.min.js';

bootstrapApplication(App, { providers: [provideHttpClient(), provideRouter(routes)] })
  .catch((err) => console.error(err));
